var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4257 20.1135H12.8441C10.663 20.111 8.57185 19.2435 7.02953 17.7011C5.48721 16.1588 4.61966 14.0677 4.61719 11.8865C4.61719 11.7411 4.67497 11.6016 4.77783 11.4987C4.88069 11.3959 5.02019 11.3381 5.16565 11.3381H27.1042C27.2496 11.3381 27.3892 11.3959 27.492 11.4987C27.5949 11.6016 27.6526 11.7411 27.6526 11.8865C27.6502 14.0677 26.7826 16.1588 25.2403 17.7011C23.698 19.2435 21.6069 20.111 19.4257 20.1135ZM5.73496 12.435C5.87523 14.225 6.68481 15.8964 8.00235 17.1162C9.3199 18.3359 11.0487 19.0145 12.8441 19.0166H19.4257C21.2212 19.0145 22.9499 18.3359 24.2675 17.1162C25.585 15.8964 26.3946 14.225 26.5349 12.435H5.73496Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7449 9.69269H3.51562V10.7896H28.7449V9.69269Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7449 11.3381H3.51562V12.435H28.7449V11.3381Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3816 10.7896H7.89698C7.31513 10.7896 6.75712 10.5585 6.34569 10.147C5.93426 9.7356 5.70313 9.17759 5.70312 8.59574C5.70312 8.01389 5.93426 7.45588 6.34569 7.04445C6.75712 6.63302 7.31513 6.40189 7.89698 6.40189H13.3816C13.9635 6.40189 14.5215 6.63302 14.9329 7.04445C15.3443 7.45588 15.5755 8.01389 15.5755 8.59574C15.5755 9.17759 15.3443 9.7356 14.9329 10.147C14.5215 10.5585 13.9635 10.7896 13.3816 10.7896ZM7.89698 7.49881C7.60606 7.49881 7.32705 7.61438 7.12133 7.8201C6.91562 8.02581 6.80005 8.30482 6.80005 8.59574C6.80005 8.88666 6.91562 9.16567 7.12133 9.37138C7.32705 9.5771 7.60606 9.69267 7.89698 9.69267H13.3816C13.6725 9.69267 13.9515 9.5771 14.1573 9.37138C14.363 9.16567 14.4785 8.88666 14.4785 8.59574C14.4785 8.30482 14.363 8.02581 14.1573 7.8201C13.9515 7.61438 13.6725 7.49881 13.3816 7.49881H7.89698Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3582 10.7896H18.8735C18.2917 10.7896 17.7337 10.5585 17.3223 10.147C16.9108 9.7356 16.6797 9.17759 16.6797 8.59574C16.6797 8.01389 16.9108 7.45588 17.3223 7.04445C17.7337 6.63302 18.2917 6.40189 18.8735 6.40189H24.3582C24.94 6.40189 25.498 6.63302 25.9095 7.04445C26.3209 7.45588 26.552 8.01389 26.552 8.59574C26.552 9.17759 26.3209 9.7356 25.9095 10.147C25.498 10.5585 24.94 10.7896 24.3582 10.7896ZM18.8735 7.49881C18.5826 7.49881 18.3036 7.61438 18.0979 7.8201C17.8922 8.02581 17.7766 8.30482 17.7766 8.59574C17.7766 8.88666 17.8922 9.16567 18.0979 9.37138C18.3036 9.5771 18.5826 9.69267 18.8735 9.69267H24.3582C24.6491 9.69267 24.9281 9.5771 25.1338 9.37138C25.3395 9.16567 25.4551 8.88666 25.4551 8.59574C25.4551 8.30482 25.3395 8.02581 25.1338 7.8201C24.9281 7.61438 24.6491 7.49881 24.3582 7.49881H18.8735Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35474 10.2411H6.25781V11.8865H7.35474V10.2411Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0032 10.2411H24.9062V11.8865H26.0032V10.2411Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8392 5.85343H11.7423C11.7375 5.2176 11.9768 4.60417 12.4108 4.13948C12.548 4.00588 12.6566 3.84588 12.7302 3.66913C12.8039 3.49239 12.8409 3.30257 12.8392 3.11111H13.9361C13.9408 3.74694 13.7015 4.36037 13.2675 4.82506C13.1304 4.95867 13.0217 5.11867 12.9481 5.29541C12.8745 5.47216 12.8374 5.66198 12.8392 5.85343Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1282 5.85343H15.0313C15.0266 5.2176 15.2659 4.60417 15.6999 4.13948C15.837 4.00588 15.9457 3.84588 16.0193 3.66913C16.0929 3.49239 16.13 3.30257 16.1282 3.11111H17.2252C17.2299 3.74694 16.9906 4.36037 16.5566 4.82506C16.4195 4.95867 16.3108 5.11867 16.2372 5.29541C16.1636 5.47216 16.1265 5.66198 16.1282 5.85343Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4251 5.85343H18.3282C18.3235 5.2176 18.5628 4.60417 18.9968 4.13948C19.1339 4.00588 19.2426 3.84588 19.3162 3.66913C19.3898 3.49239 19.4269 3.30257 19.4251 3.11111H20.522C20.5268 3.74694 20.2875 4.36037 19.8535 4.82506C19.7163 4.95867 19.6077 5.11867 19.5341 5.29541C19.4604 5.47216 19.4234 5.66198 19.4251 5.85343Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9338 19.3721L18.9062 19.7575L22.197 28.5329L23.2246 28.1475L19.9338 19.3721Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3251 19.3731L9.03125 28.1473L10.0587 28.533L13.3525 19.7588L12.3251 19.3731Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.811 27.792H21.6172V28.8889H23.811V27.792Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.647 27.792H8.45312V28.8889H10.647V27.792Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1672 16.8227H21.0703V17.9196H22.1672V16.8227Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5188 16.8227H19.4219V17.9196H20.5188V16.8227Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1641 9.1442V8.04727C22.3878 8.04727 22.7125 7.62002 22.7125 6.95035H23.8095C23.8095 8.18055 23.0866 9.1442 22.1641 9.1442Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9688 9.1442V8.04727C20.1925 8.04727 20.5172 7.62002 20.5172 6.95035H21.6141C21.6141 8.18055 20.8913 9.1442 19.9688 9.1442Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1953 9.1442V8.04727C11.4191 8.04727 11.7438 7.62002 11.7438 6.95035H12.8407C12.8407 8.18055 12.1178 9.1442 11.1953 9.1442Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.1442V8.04727C9.22377 8.04727 9.54846 7.62002 9.54846 6.95035H10.6454C10.6454 8.18055 9.92252 9.1442 9 9.1442Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbq);
export default __webpack_public_path__ + "static/media/bbq.b05ae0a0544e63c04d2e085c16de93f0.svg";
export { ForwardRef as ReactComponent };